<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商城管理
      <small>/&nbsp;导航管理</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">导航管理列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <form  style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">关键字</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="导航名称/商品名称"
                          v-model="fuzzy"
                        >
                      </div>

                      <div class="col-md-1">
                        <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick">查询</a>
                      </div>
                      <div class="col-md-7"></div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="AddClick"
                          style="float:right"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>

                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号"  width="60" align="center"></el-table-column>

                  <el-table-column prop="topMenuNae" label="导航名称" align="center"></el-table-column>
                
                
                  <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                    
                       
                        @click="RelevantClick(scope.row)"
                      >关联商品</button>
                       <button
                        class="btn btn-primary btn-sm ButtonColor"
                       
                        
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                       
                        
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">


      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container"> 
             <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled="disabled">确定</button>
          </div>
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="导航名称:" prop="topMenuNae">
            <el-input v-model="ruleForm.topMenuNae" placeholder="导航名称" class="DistributorMargin"></el-input>
          </el-form-item>
    
        
        </el-form>
        <div class="swal-footer"> 
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = "disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "LogoManagement",
  data() {
       var checkgoodsName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("导航名称不能超过32位"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      value1: "",
      outerVisible: false,
       CheckedShow: true,
       disabled:false,
      BrandList: [],
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      fuzzy: "",
      ruleForm: {},
      rules: {
         topMenuNae: [
          { required: true, message: "请输入导航名称", trigger: "blur" },
           { validator: checkgoodsName, trigger: "blur" }
        ],
      },
      UserManagementList: [],
      recom_id: ""
    };
  },
  watch:{
    pageNo: {
    　　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pageNo){
    
               this.pageNo = this.$route.params.pageNo
            }
           
       　　},
    　　immediate: true
    },
    pagesize:{
      　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pagesize){
               this.pageSize = this.$route.params.pagesize
            }
           
       　　},
    　　immediate: true
    }
  },
  computed: {
      pageNo:{
        set(val){ 
          if(val){
            
             this.pageindex = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发
       
        }
      },
      pagesize:{
        set(val){ 
          if(val){
             this.pageSize = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发
       
        }
      }
 },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    this.initdata();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
   
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    RelevantClick(row){
        this.$router.push({ path: "/relatedgoods" });
        localStorage.setItem("goodlist", JSON.stringify({row :row,pageNo: this.pageindex,pageSize: this.pageSize}));
     
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    EditClick(row){
      this.DialogTitle = "编辑";
      this.EditDialog = 1; 
       if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
        this.outerVisible = true;
        this.ruleForm = MethodsBus.cloneRow(row);
   
    },
    AddClick() {
      this.ruleForm = {};
      this.outerVisible = true;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    MakeSureRelevant(){

    },
    
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            this.disabled = true;
            const options = {
              url: "distribution/B2cMarketTopmenuController/addTopMenus",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                topMenuNae: this.ruleForm.topMenuNae,
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                     http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                 that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }else if(this.DialogTitle === '编辑'){
         that.$refs[formName].validate(valid => {
          if (valid) {
            this.disabled = true;
            const options = {
              url: "distribution/B2cMarketTopmenuController/updateTopMenus",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                topMenuNae: that.ruleForm.topMenuNae,
                topMenuId: that.ruleForm.topMenuId
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                   http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                 that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      this.disabled= true;
      const options = {
        url: "distribution/B2cMarketTopmenuController/delTopMenus",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          topMenuId: that.CurrentSelection.topMenuId,
        })
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cMarketTopmenuController/queryTopMenus",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: this.recom_id,
          size: this.pageSize,
          current: this.pageindex,
          fuzzy: this.fuzzy
        })
      };
      axios(options)
        .then(function(response) {

          if (response.data.code == 200) {
            that.totalCount = response.data.data.total;
            for (var i in response.data.data.records) {
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          
            }
            that.UserManagementList = response.data.data.records;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
.BrandTitle {
  width: 30%;
  float: left;
  list-style: none;
  color: #909399;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  font-weight: 400;
}
.BrandTitleCheck {
  width: 30%;
  float: left;
  list-style: none;
  line-height: 56px;
  height: 56px;
}
.BrandTitleUl {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 0px;
}
.BrandContent {
  width: 30%;
  float: left;
  list-style: none;
  font-size: 14px;
  color: #606266;
  height: 48px;
  line-height: 48px;
}
.CheckImg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MallPageSetting/TopNavSetting.vue